import styles from "./Button.module.scss";

export function Button({
  clickHandler,
  styleClass,
  children,
  type,
  disabled = false,
}) {
  return (
    <button
      type={type}
      className={`${styles.button} ${styleClass}`}
      onClick={clickHandler}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
